var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLactoseFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58.2 58.2",
    style: {
      enableBackground: "new 0 0 58.2 58.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3C1412;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "lactose_x5F_FREE",
    className: "st0",
    d: "M11.2,51.9l-0.8-0.6C3.9,45.7,0.1,37.6,0.1,29.1C0.1,13,13.2,0,29.2,0 c14.1,0,26.1,10,28.6,23.9l0.2,1L11.2,51.9z M19.1,25.6c0-4.7,4.2-4.9,4.4-14.2h-0.3c-0.6,0-1-0.5-1-1V6.7c0-0.6,0.5-1,1-1h11.3 c0.6,0,1,0.5,1,1v3.6c0,0.6-0.5,1-1,1h-0.3c0.2,9.3,4.4,9.6,4.4,14.2v7.1l16.1-9.3c-2.6-12-13.3-20.6-25.6-20.6 C14.8,2.8,3,14.6,3,29.1c0,7.4,3.1,14.4,8.5,19.3l7.6-4.4V25.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLactoseFree);
export default __webpack_public_path__ + "static/media/lactose-free.5da4288d5fa44c1071df629d07f3da38.svg";
export { ForwardRef as ReactComponent };